var map = {
	"./goal-white.svg": 2674,
	"./goal.svg": 678,
	"./gps-white.svg": 6865,
	"./gps.svg": 1690,
	"./home-white.svg": 9338,
	"./home.svg": 158,
	"./profile-white.svg": 8378,
	"./profile.svg": 6894
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2635;